import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ProfileRequest } from '@app/core/services/profile/models/profile-request.model';
import { MY_FORMATS } from '@app/core/services/util/util.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ProfileRequestEntryDialog {
  profileRequest: ProfileRequest;
  action: boolean;
}

@Component({
    selector: 'ap-manage-profile-request-dialog',
    templateUrl: './manage-profile-request-dialog.component.html',
    styleUrls: ['./manage-profile-request-dialog.component.css'],
    providers: [
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS
        }
    ],
    standalone: false
})
export class ManageProfileRequestDialogComponent implements OnInit {

  profileRequest: ProfileRequest;
  action: boolean;

  profileRequestFormGroup: UntypedFormGroup;
  minDate = new Date().toISOString().split("T")[0];
  endDateError = false;

  get beginDate() { return this.profileRequestFormGroup.get('beginValidityDate'); }
  get endDate() { return this.profileRequestFormGroup.get('endValidityDate'); }
  get reasonStatus() { return this.profileRequestFormGroup.get('reasonStatus'); }
  get comment() { return this.profileRequestFormGroup.get('comment'); }

  constructor(private fb: UntypedFormBuilder, private dialogRef: MatDialogRef<ManageProfileRequestDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: ProfileRequestEntryDialog) {
  }

  ngOnInit(): void {
    if (this.data.action) {
      this.action = this.data.action;
    }

    if (this.data.profileRequest) {
      this.profileRequest = this.data.profileRequest;
    }
    this.initForm();
  }

  onSubmitProfileRequestForm() {
    if (this.action) {
      this.dialogRef.close({
        beginDate: moment(this.beginDate.value).startOf('day').format('yyyy-MM-DD'),
        endDate: this.endDate.value ? moment(this.endDate.value).endOf('day').format('yyyy-MM-DD') : null,
        reasonStatus: this.reasonStatus.value,
        comment: this.comment.value
      });
    } else {
      this.dialogRef.close({
        reasonStatus: this.reasonStatus.value,
        comment: this.comment.value
      });
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

  private initForm() {
    this.profileRequestFormGroup = this.fb.group({
      beginValidityDate: this.fb.control(this.getInitBeginDate(), [Validators.required]),
      endValidityDate: this.fb.control(this.profileRequest.endValidityDate ? this.profileRequest.endValidityDate : ''),
      comment: this.fb.control(this.profileRequest.comment ? this.profileRequest.comment : '')
    });

    if (this.action) {
      this.profileRequestFormGroup.addControl("reasonStatus", this.fb.control(''));
    } else {
      this.profileRequestFormGroup.addControl("reasonStatus", this.fb.control('', [Validators.required]));
    }
    this.profileRequestFormGroup.setValidators(this.greaterThan());
  }

  private getInitBeginDate() {
    let initBeginDate = new Date();
    if (this.profileRequest.beginValidityDate && moment(new Date(this.profileRequest.beginValidityDate)).isSameOrAfter(moment(new Date()))) {
      initBeginDate = this.profileRequest.beginValidityDate;
    }
    return initBeginDate;
  }

  private greaterThan() : ValidatorFn {
    return (group: UntypedFormGroup): ValidationErrors => {
      const beginDateControl = group.get('beginValidityDate');
      const endDateControl = group.get('endValidityDate');
      if (!beginDateControl.value || !endDateControl.value) {
        endDateControl.setErrors(null);
        return;
      }

      if (new Date(beginDateControl.value).getTime() >= new Date(endDateControl.value).getTime()) {
        endDateControl.setErrors({greaterThan:true});
      } else {
        endDateControl.setErrors(null);
      }
      return;
    };
  }
}
